// components/stream-event-overlay.component.ts
import { Component, inject, OnInit, OnDestroy, signal, ElementRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StreamEventService, StreamEvent } from '../services/stream-event.service';
import { interval, Subscription } from 'rxjs';
import e from 'cors';

@Component({
  selector: 'app-stream-event-overlay',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './stream-event-overlay.component.html',
  styleUrls: ['./stream-event-overlay.component.scss']
})
export class StreamEventOverlayComponent implements OnInit, OnDestroy {
  private streamEventService = inject(StreamEventService);
  private pollingSubscription: Subscription = new Subscription();
  private videoTimer: any = null;
  @ViewChild('overlayVideo') overlayVideo!: ElementRef<HTMLVideoElement>;



  // Сигналы
  streamEvent = signal<StreamEvent | null>(null);
  showOverlay = signal<boolean>(false);

  // ID последнего показанного события чтобы избежать дублирования
  private lastShownEventId: string = '';

  ngOnInit(): void {
    this.startPolling();
  }

  ngAfterViewInit() {
    this.tryPlayVideo();
  }

  ngOnDestroy(): void {
    this.pollingSubscription.unsubscribe();
    this.clearVideoTimer();
  }

  private startPolling(): void {
    this.fetchStreamEvent();
    this.pollingSubscription = interval(60000).subscribe(() => {
      this.fetchStreamEvent();
    });
  }

  private fetchStreamEvent(): void {
    this.streamEventService.getNearestStreamEvent().subscribe(event => {
      console.log(event)
      if (event && this.shouldShowEvent(event)) {
        this.streamEvent.set(event);
        this.scheduleVideo(event);
      }
    });
  }

   private tryPlayVideo() {
    if (this.overlayVideo) {
      const videoEl = this.overlayVideo.nativeElement;
      videoEl.play().catch(err => {
        console.warn('Autoplay blocked by browser:', err);
      });
    }
  }

  private shouldShowEvent(event: StreamEvent): boolean {
    const eventDate = new Date(event.datetime);
    const now = new Date();

    const timeDiff = eventDate.getTime() - now.getTime();
    console.log(timeDiff)
    // Создаем уникальный ID события для проверки дублирования
    const eventId = `${event.datetime}-${event.title}`;
    
    // Показываем только если до события от 0 до 10 минут И это новое событие
    return timeDiff > 0 && 
           timeDiff <= 10 * 60 * 1000  &&
          eventId !== this.lastShownEventId;
  }

  private scheduleVideo(event: StreamEvent): void {
    this.clearVideoTimer();
    
    const eventDate = new Date(event.datetime);
    const now = new Date();
    const videoStartTime = new Date(eventDate.getTime() - 10 * 60 * 1000);

    if (now >= videoStartTime) {
      // Уже время показывать видео
      this.showVideo(event);
    } else {
      // Запланировать показ видео
      const timeUntilStart = videoStartTime.getTime() - now.getTime();
      this.videoTimer = setTimeout(() => {
        this.showVideo(event);
      }, timeUntilStart);
    }
  }

  private showVideo(event: StreamEvent): void {
    // Сохраняем ID события чтобы избежать повторного показа
    this.lastShownEventId = `${event.datetime}-${event.title}`;
    this.showOverlay.set(true);
  }

  private clearVideoTimer(): void {
    if (this.videoTimer) {
      clearTimeout(this.videoTimer);
      this.videoTimer = null;
    }
  }

  onVideoEnded(): void {
    // Видео завершилось (длилось 10 минут) - скрываем оверлей
    this.showOverlay.set(false);
    this.streamEvent.set(null);
  }

  onVideoError(): void {
    // В случае ошибки видео тоже скрываем оверлей
    this.showOverlay.set(false);
    this.streamEvent.set(null);
    console.error('Error loading video');
  }
}